import { useEffect } from "react";
import { useSlideContext } from "@contexts/SlideContext";
import { useParkingLot } from "@contexts/ParkingLotContext";

type UseSlideNavigationOptions = {
  onExit?: () => void;
};

export function useSlideNavigation({ onExit }: UseSlideNavigationOptions = {}) {
  const { next, prev, currentSlide, totalSlides } = useSlideContext();
  const { isDrawerOpen, toggleDrawer } = useParkingLot();

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === "p" || e.key === "P") {
        e.preventDefault();
        toggleDrawer();
        return;
      }

      if (isDrawerOpen) return;

      switch (e.key) {
        case "ArrowRight":
        case " ":
          e.preventDefault();
          next();
          break;
        case "ArrowLeft":
          e.preventDefault();
          prev();
          break;
        case "Escape":
          e.preventDefault();
          onExit?.();
          break;
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [next, prev, onExit, isDrawerOpen, toggleDrawer]);

  return { currentSlide, totalSlides, next, prev };
}
